import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../facility/stockReturnRequest/ContextAPI';
import Index from '../facility/stockReturnRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestFacility() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-facility']) return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
